import axiosClientFSR from "../axiosClientFSR";
export const aiConfigFRS = {
    getListAiParams: () => {
        return axiosClientFSR.get('/aiparam/list')
    },
    getListAiConfigByIdCam: (id) => {
        return axiosClientFSR.get(`/aiconfig/list?id_cam_department=${id}`)
    },
    editConfig: (data) => {
        return axiosClientFSR.put(`/aiconfig/edit`, data)
    },
    setDefaultConfig: (cameraCode) => {
        return axiosClientFSR.post(`/aiconfig/set-default/${cameraCode}`)
    },
    getListAiConfigRoiListByIdCamera: (id) => {
        return axiosClientFSR.get(`/aiconfigroilist/list?idCamDepartmet=${id}`)
    },
    editAiConfigRoiList: (data) => {
        return axiosClientFSR.put('/aiconfigroilist/edit', data)
    },
    getListSchedule: (param) => {
        // camera_code
        // ai_service_code
        return axiosClientFSR.get(`/aiconfig/get-schedule-ai-config`, {
            params: param
        })
    },
    getListCheckConfigAI: (param) => {
        //camera_code
        //ai_service_code
        return axiosClientFSR.get(`aiconfig/list-check-ai-config`, {
            params: param
        })
    },
    postCleningEvent: (data) => {
        // {
        //     "cameraid":"20240329000000000001",
        //     "time_keeping":9
        // }
        return axiosClientFSR.post(`/aiconfig/post-update-config-cleaning-event`, data)
    },
    postAddAiConfig: (data) => {
        return axiosClientFSR.post(`/aiconfig/post-add-ai-config`, data)
    },
    deleteConfig: (param) => {
        //camera_code
        //ai_service_code
        return axiosClientFSR.delete(`/aiconfig/delete-remove-ai-config`, {
            params: param
        })
    },
    putChangeDefaultConfig: (data, mode) => {
        return axiosClientFSR.put('/aiconfig/put-change-system-default-config', {
            list_items: data,
            mode: mode ? mode : null
        })
    }
}